import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#050505] border-t border-zinc-800" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block">
              <span className="font-heading text-2xl text-yellow-400 uppercase tracking-tight">
                Narzędzia Pro
              </span>
            </Link>
            <p className="mt-4 text-zinc-400 text-sm leading-relaxed">
              {t.footer.description}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-mono text-xs tracking-widest uppercase text-yellow-500 mb-4">{t.footer.quickLinks}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/shop" className="text-zinc-400 hover:text-white transition-colors text-sm" data-testid="footer-shop">
                  {t.footer.shopAll}
                </Link>
              </li>
              <li>
                <Link to="/shop/dewalt-batteries" className="text-zinc-400 hover:text-white transition-colors text-sm" data-testid="footer-dewalt">
                  {t.nav.powerTools}
                </Link>
              </li>
              <li>
                <Link to="/shop/milwaukee-batteries" className="text-zinc-400 hover:text-white transition-colors text-sm" data-testid="footer-milwaukee">
                  {t.nav.handTools}
                </Link>
              </li>
              <li>
                <Link to="/shop/makita-batteries" className="text-zinc-400 hover:text-white transition-colors text-sm" data-testid="footer-makita">
                  {t.nav.accessories}
                </Link>
              </li>
              <li>
                <Link to="/shop/tools-accessories" className="text-zinc-400 hover:text-white transition-colors text-sm" data-testid="footer-tools">
                  {t.nav.toolsAccessories}
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-mono text-xs tracking-widest uppercase text-yellow-500 mb-4">{t.footer.company}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-zinc-400 hover:text-white transition-colors text-sm" data-testid="footer-about">
                  {t.nav.about}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-zinc-400 hover:text-white transition-colors text-sm" data-testid="footer-contact">
                  {t.nav.contact}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-zinc-400 hover:text-white transition-colors text-sm" data-testid="footer-terms">
                  {t.footer?.terms || 'Regulamin'}
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-zinc-400 hover:text-white transition-colors text-sm" data-testid="footer-privacy">
                  {t.footer?.privacy || 'Polityka prywatności'}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-mono text-xs tracking-widest uppercase text-yellow-500 mb-4">{t.footer.contact}</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-zinc-400 text-sm">
                <Phone size={16} className="text-yellow-400" />
                +48 735 598 146
              </li>
              <li className="flex items-center gap-3 text-zinc-400 text-sm">
                <Phone size={16} className="text-yellow-400" />
                +48 690 284 078
              </li>
              <li className="flex items-center gap-3 text-zinc-400 text-sm">
                <Mail size={16} className="text-yellow-400" />
                propoziom@gmail.com
              </li>
              <li className="flex items-start gap-3 text-zinc-400 text-sm">
                <MapPin size={16} className="text-yellow-400 mt-0.5" />
                <span>Polska</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-zinc-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-zinc-500 text-sm font-mono">
            © 2024 Narzędzia Pro. {t.footer.allRights}
          </p>
          <div className="flex items-center gap-6">
            <span className="text-zinc-500 text-sm">{t.footer.trustedBy}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
